export default __webpack_public_path__ + "static/media/icon-pills.d8fdd2f7.svg";